/**
 * PATH: apps/qa/src/components/camera-capture/offlineQueue.ts
 * PURPOSE: IndexedDB-backed offline upload queue for evidence photos
 * WHY: localStorage can't store Blobs and has a 5MB limit
 */

import offlineStore from '@/lib/offlineStore'
import type { CapturedEvidence } from './types'

export async function addToOfflineQueue(
  evidence: CapturedEvidence,
  context: { attachTo?: { type: string; id: string }; inspectionId?: string }
) {
  try {
    const blob = evidence.imageBlob
    const entityType = context.attachTo?.type === 'area' ? 'area' : 'inspection'
    const entityId = context.attachTo?.id || context.inspectionId || ''

    await offlineStore.queueUpload({
      type: 'evidence',
      entityType: entityType as 'area' | 'inspection',
      entityId,
      file: blob,
      fileName: `evidence-${evidence.id}.jpg`,
      mimeType: 'image/jpeg',
      metadata: {
        evidenceId: evidence.id,
        notes: evidence.notes || '',
        gpsLatitude: evidence.gps.latitude,
        gpsLongitude: evidence.gps.longitude,
        gpsAccuracy: evidence.gps.accuracy,
        timestamp: evidence.timestamp.toISOString(),
        inspectionId: context.inspectionId || '',
      },
    })
  } catch (err) {
    if (import.meta.env.DEV) console.error('[CameraCapture] Failed to queue to IndexedDB:', err)
  }
}
